export const validationMessage = {
  required: 'Обязательно для заполнения',
  number: 'Значение должно быть числом',
  notValid: 'Некорректное значение',
  minDate: 'Дата окончания действия должна быть не раньше сегодняшнего дня',
  atLeastOneRole: 'У пользователя должна быть минимум одна роль',
  positive: 'Значение должно быть больше нуля',
  integer: 'Значение должно быть целым числом',
  onlyRusLetters: 'Значение должно содержать только буквы русского алфавита',
  onlyRussianAndSpecialLetters:
    'Значение должно содержать только буквы русского алфавита и спецсимволы',
  positiveInteger: 'Значение должно быть положительным целым числом',
  minNumber: (num: number) => `Минимальное значение ${num}`,
  maxNumber: (num: number) => `Максимальное значение ${num}`,
  minLength: (num: number, suf: string = 'символов') =>
    `Минимальная длина ${num} ${suf}`,
  maxLength: (num: number, suf: string = 'символов') =>
    `Максимальная длина ${num} ${suf}`,
};
